<script lang="ts">
							import SectionComponent from '$lib/section/SectionComponent.svelte';
							import copy from "copy-to-clipboard"; 
							import { onMount } from "svelte";
							import PrevNextSection from '$lib/prevNext/PrevNextSection.svelte';

							interface ComponentProps {
								setVisible: (id: string, v: boolean) => void;
							}
							let { setVisible }: ComponentProps = $props();
							
							const visibleById = $state<Record<string, boolean>>({});

							/**
               * This function will go through all the 'pre' elements
               * on the page and add a copy button to them.
               * Thanks to: https://slavbasharov.com/blog/adding-click-to-copy-code-markdown-blog
               */
              onMount(() => {
                  const codeBlocks = document.querySelectorAll("pre");
                  codeBlocks.forEach((block) => {
                      const copyPrompt = document.createElement("div");
                      copyPrompt.className = "copy-prompt";
                      const copyPromptText = document.createElement("p");
                      copyPromptText.innerHTML = "👆 Click to copy";
                      copyPromptText.className = 'copy-prompt-p';
                      const copyIcon = document.createElement("img");
                      copyIcon.src = "/icons/copy-icon.svg";
                      copyIcon.className = "copy-prompt-img";
                      copyPrompt.appendChild(copyIcon);
                      copyPrompt.appendChild(copyPromptText);
                      block.appendChild(copyPrompt);
											block.querySelector('.copy-prompt > p')?.addEventListener('click', () => {
												if (block.querySelector('code')?.textContent !== null && block.querySelector('code')?.textContent !== undefined) {
													copy(block.querySelector('code')!.textContent!);
												}
												if (block.querySelector('.copy-prompt > p')?.innerHTML !== null && block.querySelector('.copy-prompt > p')?.innerHTML !== undefined) {
													block.querySelector('.copy-prompt > p')!.innerHTML = 'Copied!';
													setTimeout(() => {
														block.querySelector('.copy-prompt > p')!.innerHTML = '👆 Click to copy';
													}, 1000);
												}
											});
                  });
              });
		let prevLink= '/Demo/Overview';
    let nextLink= '/Background';
    
</script>
<PrevNextSection {prevLink} {nextLink} />
<SectionComponent tag="h1" 
  id="lionweb-integration-1"
  bind:intersecting={visibleById["lionweb-integration-1"]}
  onIntersectChange={(visible) => setVisible("lionweb-integration-1", visible)}
>LionWeb Integration</SectionComponent>
<SectionComponent tag="h2" 
  id="lionweb-2"
  bind:intersecting={visibleById["lionweb-2"]}
  onIntersectChange={(visible) => setVisible("lionweb-2", visible)}
>LionWeb</SectionComponent>
<p>The LionWeb initiative (see <a target="_blank" href="https://github.com/LionWeb-io">LionWeb @ Github</a>) aims to make language engineering<br>
tools interoperable on the web.<br>
LionWeb does this by specifying</p>
<ul>
<li>how language definitions and models can be interchanged in a well-defined JSON format.</li>
<li>a server protocol for storing and retrieving models in a repository.</li>
</ul>
<p>Next to the specification, LionWeb also provides implementations of supporting software in languages like TypeScript, JavaScript,<br>
Java, Kotlin, C#.<br>
These packages support a wide range of functionality like:</p>
<ul>
<li>(de)serialization between in-memory models and JSON format</li>
<li>model diff</li>
<li>model validation</li>
<li>etc.</li>
</ul>
<p>There also is a <code>lionweb-repository</code> package that implements a LionWeb server for model storage using the LionWeb server protocol.</p>
<SectionComponent tag="h2" 
  id="freon-and-lionweb-3"
  bind:intersecting={visibleById["freon-and-lionweb-3"]}
  onIntersectChange={(visible) => setVisible("freon-and-lionweb-3", visible)}
>Freon and LionWeb</SectionComponent>
<p>The LionWeb idea of interoperability fits perfectly with the basic principles of Freon, to be <em>open</em> and <em>extensible</em>.</p>
<p>Freon uses LionWeb in various ways as described in the sections below.</p>
<p>The use of LionWeb allows other tools access not only to the models, but also to the languages that are defined in Freon.<br>
It also means that there is no lock-in when using Freon.<br>
Both the languages and models created with Freon are fully accessible anywhere else.</p>
<h3 id="store-models-in-lionweb-format-1">Store models in LionWeb Format</h3>
<p>Freon stores models in LionWeb JSON format on the server, allowing other tools to access the models.</p>
<h3 id="using-the-lionweb-repository-2">Using the LionWeb Repository</h3>
<p>Optionally use the LionWeb server protocol to store models in the lionweb-repository.<br>
This option is still in beta, as we want to do more testing.</p>
<ul>
<li>To run the lionweb-repository see the GitHub page  
<a target="_blank" href="https://github.com/LionWeb-io/lionweb-repository">https://github.com/LionWeb-io/lionweb-repository</a>.  
Once the lionweb-repository is running, the following two lines in `starter.ts`
</li>
</ul>
<pre class="language-ts"><code class="language-ts">import &#123; ServerCommunication &#125; from "@freon4dsl/core";
WebappConfigurator.getInstance().setServerCommunication(ServerCommunication.getInstance());</code></pre>
<p>need to be changed to:</p>
<pre class="language-ts"><code class="language-ts">import &#123; LionWebRepositoryCommunication &#125; from "@freon4dsl/core"
WebappConfigurator.getInstance().setServerCommunication(LionWebRepositoryCommunication.getInstance());</code></pre>
<h3
  id="convert-freon-language-definition-to-lionweb-3"
>Convert Freon Language Definition to LionWeb</h3>
<ul>
<li>Optionally convert the Freon language definition (the .ast files) to a LionWeb language definition<br>
in LionWeb JSON format.</li>
<li>This is done by the following command:  
<pre class="language-bash"><code class="language-bash">freon lionweb-it -d src/defs -o src/freon</code></pre>
This will create a file <code>src/freon/lionweb/&lt;LanguageName&gt;.json</code> containing the LionWeb<br>
definition for <code>&lt;languageName&gt;</code>.<br>
Note that this is a beta feature.</li>
</ul>


<PrevNextSection {prevLink} {nextLink} />